import React, { useState, useEffect, useMemo } from "react";

export const Header = (props) => {
  const roles = useMemo(
    () => (props.data && props.data.roles ? props.data.roles : []),
    [props.data]
  );
  const [roleIndex, setRoleIndex] = useState(0);
  const [displayed, setDisplayed] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!roles.length) return;
    const current = roles[roleIndex];
    let timeout;

    if (!isDeleting && displayed.length < current.length) {
      timeout = setTimeout(
        () => setDisplayed(current.slice(0, displayed.length + 1)),
        80
      );
    } else if (!isDeleting && displayed.length === current.length) {
      timeout = setTimeout(() => setIsDeleting(true), 2200);
    } else if (isDeleting && displayed.length > 0) {
      timeout = setTimeout(() => setDisplayed(displayed.slice(0, -1)), 40);
    } else if (isDeleting && displayed.length === 0) {
      setIsDeleting(false);
      setRoleIndex((i) => (i + 1) % roles.length);
    }

    return () => clearTimeout(timeout);
  }, [displayed, isDeleting, roleIndex, roles]);

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <div className="intro-label">Hello, I&rsquo;m</div>
                <h1>{props.data ? props.data.title : "Udayan Joshi"}</h1>
                <div className="profile-image-container">
                  <img
                    src="img/UJ_ProfilePic.png"
                    alt="Udayan Joshi"
                    className="profile-image"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                  <div className="profile-image-placeholder">
                    <i className="fa fa-user"></i>
                  </div>
                </div>
                <div className="typewriter-container">
                  <span>{displayed}</span>
                  <span className="typewriter-cursor">|</span>
                </div>
                <p>{props.data ? props.data.paragraph : "Loading..."}</p>
                <div className="intro-cta">
                  <a href="#about" className="btn btn-custom btn-lg page-scroll">
                    Explore My Work
                  </a>
                  <a
                    href="#contact"
                    className="btn btn-outline btn-lg page-scroll"
                  >
                    Get In Touch
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-indicator">
          <span></span>
        </div>
      </div>
    </header>
  );
};
